/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

const additionalfn = {
  showWhatsapp: function() {
    if (typeof document !== 'undefined') {
      if (document.getElementById("at-share-dock")) {
        document.getElementById("at-share-dock").style.display = "block";
      }
      if(document.querySelector('.trustpilot-widget-header')) {
        document.querySelector('.trustpilot-widget-header').style.display = "inherit";
      }
    }
  },
  hideWhatsapp: function() {
    if (typeof document !== 'undefined') {
      if (document.getElementById("at-share-dock")) {
        document.getElementById("at-share-dock").style.display = "none";
      }
      if(document.querySelector('.trustpilot-widget-header')) {
        document.querySelector('.trustpilot-widget-header').style.display = "none";
      }
    }
  },
  getDeviceProperties: function() {
    const isClient = typeof window === "object";

    const width = isClient ? window.innerWidth : undefined,
      height = isClient ? window.innerHeight : undefined,
      orientation = width > height ? "landscape" : "portrait";

    const userAgent = isClient ? navigator.userAgent.toLowerCase() : '';
    const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
      userAgent
    );
    const isMobile =
      (!isTablet && width < 768) || (!isTablet && height < 400) ? true : false;
    const isDesktop = !isTablet && !isMobile ? true : false;

    var properties = {
      desktop: isDesktop,
      mobile: isMobile,
      tablet: isTablet,
      height: height,
      orientation: orientation,
      width: width
    };

    return properties;
  },
  getMinMax: function(params) {
    var min = false,
      max = false,
      value = null;

    for (var i = 0; i < params.data.length; i++) {
      value = parseInt(params.data[i][params.key]);

      if (!isNaN(value)) {
        // is number
        if (min) {
          if (value < min) min = parseInt(params.data[params.key][i]);
        } else {
          // first instance
          min = value;
        }

        if (max) {
          if (value > max) max = value;
        } else {
          // first instance
          max = value;
        }
      }
    }

    return {
      min: min,
      max: max
    };
  },
  getURLParameters: function(route, params) {
    var split = window.location.href.split("/"),
      value = params && params.defaultValue ? params.defaultValue : null;

    for (var i = 0; i < split.length; i++) {
      if (split[i] === route) {
        if (split[i + 1] !== undefined) {
          value = split[i + 1];
          break;
        }
      }
    }

    if (value && params && params.type) {
      switch (params.type) {
        case "int":
          value = parseInt(value);
          break;
        default:
          break;
      }
    }

    return value;
  },
  getSearchRoute: function(params) {
    var route = "",
      specialRoutes = ["search_viewed", "search_favourite"],
      defaultParams = {
        perpage: params.perpage,
        slideshowImages: params.slideshowImages
      };

    if (specialRoutes.includes(params.query)) {
      switch (params.query) {
        case "search_viewed":
          route = params.r("search_viewed_accommodations", {
            slideshowImages: params.slideshowImages
          });
          break;
        case "search_favourite":
          route = params.r("search_favourite_accommodations", {
            slideshowImages: params.slideshowImages
          });
          break;
      }
    } else if (params.sort && params.page) {
      if (params.query) {
        defaultParams.sortBy = params.sort;
        defaultParams.page = params.page;
        defaultParams.query = params.query;
        route = params.r(
          "search_results_and_fields_sorted_paged",
          defaultParams
        );
      } else {
        defaultParams.sortBy = params.sort;
        defaultParams.page = params.page;
        route = params.r(
          "search_results_and_fields_sorted_paged",
          defaultParams
        );
      }
    } else if (params.sort) {
      if (params.query) {
        defaultParams.sortBy = params.sort;
        defaultParams.query = params.query;
        route = params.r("search_results_and_fields_sort_query", defaultParams);
      } else {
        defaultParams.sortBy = params.sort;
        route = params.r("search_results_and_fields_sort", defaultParams);
      }
    } else if (params.page) {
      defaultParams.page = params.page;
      defaultParams.query = params.query;
      route = params.r("search_results_and_fields_page_query", defaultParams);
    } else {
      defaultParams.query = params.query;
      route = params.r("search_results_and_fields", defaultParams);
    }

    if (params.searchURLBase) route = params.searchURLBase + route;

    return route;
  },
  labelNumbers: function(params) {
    for (var i = 0; i < params.data.length; i++) {
      if (parseInt(params.data[i].key) > 1)
        params.data[i].label = params.data[i].key + " " + params.plural;
      else params.data[i].label = params.data[i].key + " " + params.singular;
    }

    return params.data;
  },
  isMobile: function() {
    const size = useWindowSize();
    const mobile = size.width !== undefined && size.width < 768;

    return mobile;
  },
  formatDate: function(date) {
    var month = date.month + 1,
      month = month < 10 ? "0" + month : month,
      day = date.day < 10 ? "0" + date.day : date.day;

    var format = parseInt(date.year + "" + month + "" + day);

    return format;
  },
  getCenterFromLatLng: function(data) {
    if (data.length === 1)
      return {
        lat: data[0].latitude,
        lng: data[0].longitude
      };

    var X = 0.0;
    var Y = 0.0;
    var Z = 0.0;

    for (var i = 0; i < data.length; i++) {
      var lat = (data[i].latitude * Math.PI) / 180;
      var lon = (data[i].longitude * Math.PI) / 180;
      var a = Math.cos(lat) * Math.cos(lon);
      var b = Math.cos(lat) * Math.sin(lon);
      var c = Math.sin(lat);

      X += a;
      Y += b;
      Z += c;
    }

    X /= data.length;
    Y /= data.length;
    Z /= data.length;

    lon = Math.atan2(Y, X);
    var hyp = Math.sqrt(X * X + Y * Y);
    lat = Math.atan2(Z, hyp);

    var finalLat = (lat * 180) / Math.PI;
    var finalLng = (lon * 180) / Math.PI;

    return {
      lat: finalLat,
      lng: finalLng
    };
  },
  getCookie: function(c_name) {
    var i,
      x,
      y,
      ARRcookies = document.cookie.split(";");
    for (i = 0; i < ARRcookies.length; i++) {
      x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
      y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
      x = x.replace(/^\s+|\s+$/g, "");
      if (x === c_name) {
        return unescape(y);
      }
    }
  },
  keepRange: function(params) {
    var start = null,
      end = null;

    if (params.max >= params.end) {
      // range larger than number of items
      start = 1;
      end = params.end;
    } else {
      if (params.current <= params.end - params.max) {
        // range within number of items
        start = params.current;
        end = params.current + params.max - 1;
      } else {
        // current is bigger than start of range
        start = params.end - params.max + 1;
        end = params.end;
      }
    }

    return [start, end];
  },
  key_label_from_value: function(params) {
    var formatted = [],
      key = null;

    for (var i = 0; i < params.data.length; i++) {
      if (params.data[i].value && params.data[i].value.length > 0) {
        // key = params.lowercase_key
        //   ? params.data[i].value.toLowerCase()
        //   : params.data[i].value;
        // key = params.key_space_as_hyphen
        //   ? key.replace(/ - /gi, "-").replace(/ /gi, "-")
        //   : key;
        // key = params.key_space_as_none ? key.replace(/ /gi, "") : key;
        key = params.data[i].value;
        formatted.push({
          key: key,
          label: params.data[i].label
        });
      }
    }

    return formatted;
  },
  mToKm(value) {
    if (value < 1000) return value + "m";
    else {
      return value / 1000 + "km";
    }
  },
  jsUcfirst: function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },
  localToDomainExtension: function(local) {
    switch (local) {
      case "da":
        return "dk";
        break;
      case "en":
        return "com";
        break;
      default:
        return local;
        break;
    }
  },
  orientation: function() {
    if (typeof window !== "undefined" && window.screen.orientation) {
      if (window.screen.orientation.type.indexOf("landscape") !== -1)
        return "landscape";
      else return "portrait";
    }
  },
  tablet_as_mobile: function(is_mobile, is_tablet) {
    if (is_mobile) return true;

    if (is_tablet && additionalfn.orientation() === "portrait") return true;

    return false;
  },
  updateURL: function(params) {
    let route = "";

    if (
      params.query === "search_viewed" ||
      params.query === "search_favourite"
    ) {
      switch (params.query) {
        case "search_viewed":
          route = params.r("viewed_accommodations");
          break;
        case "search_favourite":
          route = params.r("favourite_accommodations");
          break;
        default:
          break;
      }
    } else if (params.sort && params.page && params.page > 1) {
      route = params.r("search_sorted_paginated", {
        page: params.page,
        sortBy: params.sort,
        query: params.query
      });
    } else if (params.sort) {
      route = params.r("search_sorted", {
        sortBy: params.sort,
        query: params.query
      });
    } else if (params.page && params.page > 1) {
      if (params.query) {
        route = params.r("search_paginated", {
          page: params.page,
          query: params.query
        });
      } else {
        route = params.r("search_paginated_no_query", { page: params.page });
      }
    } else {
      if (params.query && params.query.length > 0)
        route = params.r("search", { query: params.query });
      else route = params.r("homepage");
    }

    window.history.pushState({}, "", route);
  },
  setCookie: function(c_name, value, exdays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    var c_value =
      escape(value) +
      (exdays === null ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = c_name + "=" + c_value + "; path=/";
  },
  setObjectFirstProperty: function(obj, property, find) {
    var newObj = [];

    for (var i in obj) {
      if (obj[i][property] === find) {
        newObj.push(obj[i]);
      }
    }

    for (var i in obj) {
      if (obj[i][property] !== find) {
        newObj.push(obj[i]);
      }
    }

    return newObj;
  },
  stringify: function(params) {
    const pairs = Object.keys(params).map(key => {
      return key + "/" + params[key];
    });

    return pairs.join("/");
  },
  stripStringtoNumber: function(stringNumber, rule) {
    if (!isNaN(stringNumber)) return stringNumber;

    var number = parseInt(stringNumber.replace(/\D/g, ""));

    if (rule) {
      switch (rule) {
        case ">=+":
          if (stringNumber.indexOf(">") !== -1) number++;
          break;
        default:
          break;
      }
    }

    return number;
  },
  today: function() {
    var currentdate = new Date();

    return this.formatDate({
      year: currentdate.getFullYear(),
      month: currentdate.getMonth(),
      day: currentdate.getDate()
    });
  },
  todayWithOffset: function (offset) {
    var offsetDate = new Date();
    offsetDate.setDate(offsetDate.getDate() + parseInt(offset));
    return this.formatDate({
      year: offsetDate.getFullYear(),
      month: offsetDate.getMonth(),
      day: offsetDate.getDate()
    });
  },
  tokenize: function(query) {
    if (query == undefined) return {};

    var tokens = query.split("/");
    var params = {};
    if (tokens.length > 1) {
      for (var i = 0, len = tokens.length; i < len; i += 2) {
        params[tokens[i]] = tokens[i + 1];
      }
    }

    return params;
  },
  urlToLocale: function(url, locale) {
    var doubleSlashes = url.split("//"),
      singleSlahes = doubleSlashes[1].split("/"),
      dots = singleSlahes[0].split(".");

    dots.pop();
    dots.push(locale);

    var newURL = doubleSlashes[0] + "//" + dots.join(".");

    if (singleSlahes.length > 1) {
      singleSlahes.shift();
      newURL += "/" + singleSlahes.join("/");
    }

    return newURL;
  },
  visibleOnScreen: function(element) {
    var screen_top_position = window.scrollY;
    var screen_bottom_position = screen_top_position + window.innerHeight;

    var element_top_position = element.offsetTop;
    var element_bottom_position = element_top_position + element.offsetHeight;

    return (
      inRange(
        element_top_position,
        screen_top_position,
        screen_bottom_position
      ) ||
      inRange(
        element_bottom_position,
        screen_top_position,
        screen_bottom_position
      )
    );
  }
};

export default additionalfn;

export const getExtraFieldsRoute = (r, query) => {
  return r("api_post_search_aggregations", { query });
};
